module.exports = __webpack_public_path__ + "media/images/area/area_miyagiM400-e89a82bcc7611ddaba08e8692d9742c8.jpg";